import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { IFeaturesDataResolveData } from './features-data.data';
import { FeaturesDataStore } from './features-data.store';
import { map } from 'rxjs/operators';

@Injectable()
export class FeaturesDataResolve implements Resolve<IFeaturesDataResolveData> {
  static RESOLVE = {
    // key is the same as the RESOLVE_KEY in features-data.data.ts
    // couldn't use RESOLVE_KEY here because AOT compilation won't allow it in routes
    featuresData: FeaturesDataResolve,
  };

  constructor(private _featuresDataStore: FeaturesDataStore) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IFeaturesDataResolveData> {
    return forkJoin(
      this._featuresDataStore.getFeatureToggles(),
      this._featuresDataStore.getPurchaseInfo(),
      this._featuresDataStore.getBannersCanvases(),
      this._featuresDataStore.getAccountQuotas(),
      this._featuresDataStore.getCurrentPlan(),
      this._featuresDataStore.getFeaturePayloads()
    ).pipe(
      map(
        ([
          toggles,
          purchaseInfo,
          bannersCanvases,
          accountQuotas,
          currentPlan,
          payloads,
        ]) => ({
          toggles,
          purchaseInfo,
          bannersCanvases,
          accountQuotas,
          currentPlan,
          payloads,
        })
      )
    );
  }
}
